<template>
    <div class="research-literature">
        <div class="filter-bar">
            <div class="filter-item">
                <span class="filter-label">分类</span>
                <el-select size="small" v-model="filters.category" placeholder="全部" clearable>
                    <el-option label="全部" value="" />
                    <el-option
                        v-for="item in categoryOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    />
                </el-select>
            </div>
            <div class="filter-actions">
                <el-button size="small" type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                <el-button size="small" type="danger" plain icon="el-icon-refresh-left" @click="handleReset">重置</el-button>
            </div>
        </div>

        <el-table
            class="literature-table"
            :data="pageList"
            :header-cell-style="headerCellStyle"
            stripe
            size="small"
        >
            <el-table-column
                type="index"
                label="序号"
                width="70"
                align="center"
                :index="indexMethod"
            />
            <el-table-column prop="title" label="标题" min-width="220">
                <template slot-scope="scope">
                    <overflow-text :text="scope.row.title || ''" />
                </template>
            </el-table-column>
            <el-table-column prop="abstract" label="摘要" min-width="320">
                <template slot-scope="scope">
                    <overflow-text :text="scope.row.abstract || ''" />
                </template>
            </el-table-column>
            <el-table-column prop="category" label="分类" width="120" align="center" />
        </el-table>

        <el-pagination
            class="page-wrap"
            background
            layout="total, prev, pager, next, jumper"
            :current-page="pageInfo.pageNum"
            :page-size="pageInfo.pageSize"
            :total="pageInfo.total"
            @current-change="changePage"
        />
    </div>
</template>

<script>
import OverflowText from './overflow_text.vue';
const EMPTY_FILTERS = {
    category: '',
};

export default {
    name: 'ResearchLiterature',
    components: { OverflowText },
    props: {
        allList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            filters: { ...EMPTY_FILTERS },
            appliedFilters: { ...EMPTY_FILTERS },
            pageInfo: {
                pageNum: 1,
                pageSize: 10,
                total: 0,
            },
            headerCellStyle: {
                background: '#F5F7FA',
                color: '#303133',
                fontWeight: 'bold',
            },
        };
    },
    computed: {
        categoryOptions() {
            return [...new Set(this.allList.map((item) => item.category))];
        },
        filteredList() {
            const { category } = this.appliedFilters;
            return this.allList.filter((item) => {
                if (category && item.category !== category) return false;
                return true;
            });
        },
        pageList() {
            const { pageNum, pageSize } = this.pageInfo;
            const start = (pageNum - 1) * pageSize;
            return this.filteredList.slice(start, start + pageSize);
        },
    },
    watch: {
        allList() {
            this.handleReset();
        },
        filteredList: {
            immediate: true,
            handler(list) {
                this.pageInfo.total = list.length;
                const maxPage = Math.max(1, Math.ceil(list.length / this.pageInfo.pageSize) || 1);
                if (this.pageInfo.pageNum > maxPage) {
                    this.pageInfo.pageNum = maxPage;
                }
            },
        },
    },
    methods: {
        indexMethod(index) {
            return (this.pageInfo.pageNum - 1) * this.pageInfo.pageSize + index + 1;
        },
        handleSearch() {
            this.appliedFilters = { ...this.filters };
            this.pageInfo.pageNum = 1;
        },
        handleReset() {
            this.filters = { ...EMPTY_FILTERS };
            this.appliedFilters = { ...EMPTY_FILTERS };
            this.pageInfo.pageNum = 1;
        },
        changePage(page) {
            this.pageInfo.pageNum = page;
        },
    },
};
</script>

<style lang="less" scoped>
.research-literature {
    .filter-bar {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 12px 16px;
        margin-bottom: 16px;
    }

    .filter-item {
        display: flex;
        align-items: center;

        .filter-label {
            margin-right: 8px;
            font-size: 14px;
            color: #303133;
            white-space: nowrap;
        }

        .el-select {
            width: 140px;
        }
    }

    .filter-actions {
        display: flex;
        align-items: center;
        gap: 8px;

        .el-button--primary {
            background: #165DFF;
            border-color: #165DFF;
        }
    }

    .literature-table {
        width: 100%;

        ::v-deep .el-button--text {
            color: #165DFF;
            padding: 0 4px;
        }
    }

    .page-wrap {
        margin-top: 16px;
        text-align: right;
    }
}
</style>
